import { Box, styled } from '@mui/system';

export const StyledContainer = styled(Box)(({ isPhone }: { isPhone: boolean }) => ({
  position: 'absolute',
  top: 0,
  left: isPhone ? 0 : '78px',
  right: 0,
  height: isPhone ? '56px' : '70px',
  padding: isPhone ? '8px 24px' : '16px 24px 16px 5px',
  backgroundColor: '#05374A',
  zIndex: 99,
  boxSizing: 'border-box'
}));

export const VerticalSeparator = styled(Box)({
  width: '1px',
  margin: '0px 10px',
  backgroundColor: '#ECECEC'
});

export const HorizontalSeparator = styled(Box)({
  height: '1px',
  backgroundColor: '#ECECEC'
});
